import * as React from 'react';

export interface IDtpInstructionsProps {
    eshopName?: string;
}

export const DtpInstructions = (props: IDtpInstructionsProps) => {
    return (
        <div className="dtp-portal-card">
            <div className="title">
                <span>Instructions</span>
            </div>
            <div className="content">
                <p>
                    User at your website <b>{props.eshopName}</b> has uploaded logo file and automatic processing and conversion into raster image for visualizations has failed!
                    Logo needs to be processed manually by yours DTP artist.
            </p>
                <span>Procedure is easy:</span>
                <b>
                    <ol>
                        <li>Download original file uploaded by user</li>
                        <li>Open in your graphics software (Adobe/Corel etc.)</li>
                        <li>Export clean logo in 300dpi raster as transparent PNG file in CMYK colors</li>
                        <li>Upload PNG on this page = logo will be added to user's gallery and user will be automatically notified by e-mail</li>
                    </ol>
                </b>
                <p>If you are <b>unable to open uploaded file</b> (invalid file) or contains of file is not regular logo, just write short message and click to "INVALID LOGO".</p>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/dtp-portal/cards/dtp-instructions.component.tsx